"use strict";

class BuyerAuthorizeBrokersController {
    constructor($scope, $timeout, NgMap, SSHttpService, SSUtilService, SSSearchService, SSAppService, SSUserService, SSConfigService, SSAlertService, TWOFAService) {

        const self = this;

        self.$scope = $scope;
        self.$timeout = $timeout;

        self.NgMap = NgMap;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSSearchService = SSSearchService;
        self.SSAppService = SSAppService;
        self.SSUserService = SSUserService;
        self.SSConfigService = SSConfigService;
        self.SSAlertService = SSAlertService;
        self.TWOFAService = TWOFAService;

        self.buyer_token = SHOWSUITE.data.token;
        self.eoi_no = SHOWSUITE.data.eoi_no;
        self.eoi = null;
        self.units = [];

        self.verifiedBrokers = [];
        self.modal = false;
        self.verificationProcessComplete = false;
        self.buyer_contact = null;


        self.init();

    }

    init() {

        const self = this;

        let url = 'eois/' + self.eoi_no;
        let params = {
            "buyer_token" : self.buyer_token
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.eoi = response.data.eoi;
            self.units = response.data.units;

        });
    }

    verifyBrokers(){

        const self = this;
        self.verifiedBrokers = [];

        for(let i=0; i<self.eoi.brokers.length; i++){
            console.log("self.eoi.brokers[i].verified" + self.eoi.brokers[i].verified);
            if(self.eoi.brokers[i].verified === true){
                self.verifiedBrokers.push((self.eoi.brokers[i].id))
            }
        }
        console.log("self.verifiedBrokers" + JSON.stringify(self.verifiedBrokers));



        let url = 'eois/' + self.eoi_no + '/authorize_brokers';
        let params = {
            "buyer_token" : self.buyer_token,
            "broker_user_ids" : self.verifiedBrokers.toString()
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.buyer_contact = self.hideFrontPhoneNumber(response.data.buyer_contact);
            self.verify2FA(response);
        });

    }

    verify2FA(response){
        const self = this; 

        // params can be: title, message, prefix_2fa etc
        let params = {};

        if(response && response.data && response.data.prefix_2fa){
            params.prefix_2fa = response.data.prefix_2fa;
        }

        params.title = "<small>Authorisation by a Registered User of Showsuite</small>";
        
        let message = "<p><small>Dear buyer, before proceeding, ";
        message += "you would need to key in the 6-digit verification code that would be sent to your mobile number &lt;</small>";
        message += "<label>"+ self.buyer_contact +"</label>&gt;</p>";
        message += "<p>Enter the 6-digit verification code within 5 minutes.</p>";
        
        params.message = message;

        // Params for 'resendCode'
        // 'resendCode' must have 'url', 'requesMethod' and 'subParams'
        params.resendCode = {
            'url': 'eois/' + self.eoi_no + '/authorize_brokers',
            'requestMethod': 'POST',
            'subParams': {
                "buyer_token" : self.buyer_token,
                "broker_user_ids" : self.verifiedBrokers.toString()
            }
        };

        self.TWOFAService.verify2FA(params, function(response){
            if(response.success === true){
                self.verificationProcessComplete = true;
            }
        });
    }

    hideFrontPhoneNumber(phone_number) {
        console.log("phone_number: " . phone_number);
        return phone_number.replace(/.(?=.{4,}$)/g, 'X');
    };
}

BuyerAuthorizeBrokersController.$inject = ['$scope', '$timeout', 'NgMap', 'SSHttpService', 'SSUtilService', 'SSSearchService', 'SSAppService', 'SSUserService', 'SSConfigService', 'SSAlertService', 'TWOFAService'];
app.controller('BuyerAuthorizeBrokersController', BuyerAuthorizeBrokersController);
